import React, { useEffect, useState } from "react";
import { Navigate, useNavigate, useParams, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import MainLayout from "../components/layout/MainLayout";
import Breadcrumbs from "../components/common/Breadcrumbs";
import Swal from "sweetalert2";
import { selectHasPermission } from "../store/slices/authSlice";
import UserSessionList from "../pages/UserSession/UserSessionList";
import {
    fetchUserSessions,
    deleteUserSession,
} from "../store/slices/userSessionSlice";

const UserSessions = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const canManageSessions = useSelector((state) =>
        selectHasPermission(state, "user-sessions-manage")
    );
    const canCreateSessions = useSelector((state) =>
        selectHasPermission(state, "user-sessions-create")
    );
    const canEditSessions = useSelector((state) =>
        selectHasPermission(state, "user-sessions-edit")
    );
    const canDeleteSessions = useSelector((state) =>
        selectHasPermission(state, "user-sessions-delete")
    );

    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        setIsLoading(true);
        dispatch(fetchUserSessions()).finally(() => setIsLoading(false));
    }, [dispatch]);

    const handleAddSession = () => {
        navigate(`/sessions/add`);
    };

    const handleEditSession = (id) => {
        navigate(`/sessions/edit/${id}`);
    };

    const handleDeleteSession = async (id) => {
        const result = await Swal.fire({
            title: "Are you sure?",
            text: "You want to delete this session record?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!",
            cancelButtonText: "Cancel",
        });

        if (result.isConfirmed) {
            try {
                await dispatch(deleteUserSession(id)).unwrap();
                Swal.fire("Deleted!", "Session has been deleted.", "success");
            } catch (err) {
                Swal.fire("Error!", err.message || "Failed to delete session.", "error");
            }
        }
    };

    if (!canManageSessions) {
        return (
            <Navigate
                to="/dashboard"
                state={{ error: "You do not have permission to view sessions." }}
                replace
            />
        );
    }

    return (
        <MainLayout>
            <div className="container-xxl flex-grow-1 container-p-y">
                <Breadcrumbs />

                <div className="card">
                    <div className="card-body">
                        {isLoading ? (
                            <div className="d-flex justify-content-center py-5">
                                <div className="spinner-border" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                            </div>
                        ) : (
                            <UserSessionList
                                onEditSession={canEditSessions ? handleEditSession : null}
                                onDeleteSession={canDeleteSessions ? handleDeleteSession : null}
                                onAddSession={canCreateSessions ? handleAddSession : null}
                            />
                        )}
                    </div>
                </div>
            </div>
        </MainLayout>
    );
};

export default UserSessions;
